module.exports = __webpack_public_path__ + "front/img/88_a.8ae9ccbc.png";